import React from "react";
import classes from "./ProductGallery.module.scss";
const ProductGallery = ({ image }) => {
  return (
    <section className={`${classes.product_gallery} ${classes.container}`}>
      <div className={classes.imageGroup}>
        <img src={image[0]} className={classes.img1} alt="img" />
        <img src={image[1]} className={classes.img2} alt="img" />
      </div>
      <section className={classes.img3}>
        <img src={image[2]} alt="img" />
      </section>
    </section>
  );
};

export default ProductGallery;
